const $ = jQuery;
const $window = $(window);

// Dock Map Popover settings & Initialization.
const initDocksMap = () => {
  const els = once('docks-map', '.p-st-docks-map');
  els.forEach(() => {
    const options = {
      container: '.pst-dock-pins',
      trigger: 'focus',
      placement() {
        if ($(window).width() < 768) {
          return 'bottom';
        }
        return 'right';
      },
    };
    $('[data-toggle=popover]').popover(options);
  });
};

$window.on('load', () => initDocksMap());
